import { Checkbox, ListItem, Stack, TextField } from "@mui/material";
import InputControl from "../../../shared/components/InputControl";

export const PromosAndNotificationFilterSection = ({
  state,
  statusOptions = [],
  storeOptions = [],
  typeOptions = [],
  onChange,
}) => {
  return (
    <Stack direction="row" spacing={2}>
      <InputControl
        type="dropdown"
        name="status"
        label="Status"
        options={statusOptions}
        value={state.status}
        onChange={(_, value) => onChange({ name: "status", value })}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderOption={(props, option, { selected }) => (
          <ListItem {...props} key={option.value}>
            {option.label}
          </ListItem>
        )}
        sx={{ width: "160px" }}
        renderInput={(params) => (
          <TextField {...params} label="Status" placeholder="Select Status" />
        )}
      />
      <InputControl
        type="dropdown"
        name="type"
        label="Type"
        options={typeOptions}
        value={state.type}
        onChange={(_, value) => onChange({ name: "type", value })}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderOption={(props, option, { selected }) => (
          <ListItem {...props} key={option.value}>
            {option.label}
          </ListItem>
        )}
        sx={{ width: "160px" }}
        renderInput={(params) => (
          <TextField {...params} label="Type" placeholder="Select Type" />
        )}
      />
      <InputControl
        type="dropdown"
        name="store"
        label="Store"
        multiple
        options={storeOptions}
        value={state.store}
        disableCloseOnSelect
        disableClearable={true}
        renderTags={() => null}
        onChange={(_, value) => onChange({ name: "store", value })}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderOption={(props, option, { selected }) => (
          <ListItem {...props} key={option.id}>
            <Checkbox checked={selected} style={{ marginLeft: "-8px" }} />
            {option.name}
          </ListItem>
        )}
        sx={{ width: "250px" }}
        renderInput={(params) => (
          <TextField {...params} label="Store" placeholder="Select store" />
        )}
      />
    </Stack>
  );
};
